import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"font-style":"italic"} }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Download ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!

  return (_openBlock(), _createBlock(_component_el_timeline, { class: "mt-3" }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documents, (doc) => {
        return (_openBlock(), _createBlock(_component_el_timeline_item, {
          color: "green",
          key: doc.createdDate,
          size: "large",
          hollow: false
        }, {
          default: _withCtx(() => [
            _createElementVNode("b", null, _toDisplayString(doc.actionName), 1),
            _createElementVNode("span", null, [
              _createElementVNode("p", null, _toDisplayString(_ctx.showContentChangeHistory(doc)), 1),
              _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.formatTime(doc.createdDate)), 1),
              (_ctx.userType === 'agency')
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                    (doc?.seller)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(doc?.seller?.email), 1))
                      : _createCommentVNode("", true),
                    (doc?.agency)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(doc?.agency?.email), 1))
                      : _createCommentVNode("", true),
                    (doc?.user)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(doc?.user?.email), 1))
                      : _createCommentVNode("", true),
                    (doc?.log?.fileUrl)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                          _createVNode(_component_el_link, {
                            type: "primary",
                            href: doc.log.fileUrl,
                            title: "Download file",
                            target: "_blank",
                            rel: "noopener noreferrer"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_7
                            ]),
                            _: 2
                          }, 1032, ["href"])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }))
}